module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "v5-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.next($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29b7172d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@58fe/v5/src/components/x-button/index.vue
// module id = 338
// module chunks = 0